/* eslint-disable react-hooks/exhaustive-deps */
import saveAs from "file-saver"
import { FC, useCallback, useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { DropzoneOptions, useDropzone } from "react-dropzone"
import { useDispatch } from "react-redux"
import { AppDispatch } from "../../../../.."
import {
  ModalOuter,
  TModalTypes,
} from "../../../../../components/Modal/ModalOuter"
import { setAlerts } from "../../../../../globalStore/alertStore"
import { TPictureFile } from "../../../../../globalStore/pageStore/zyomuinMaster/baseData"
import {
  TClaimrekiFile,
  TZikorekiFile,
} from "../../../../../globalStore/pageStore/zyomuinMaster/kakusyuRirekiData"
import ContentService from "../../../../../service/content/contentService"

export type TFileUploadModal = TModalTypes & {
  isShowFileImage: boolean
  fileData?: TPictureFile | TZikorekiFile | TClaimrekiFile
  fileImageUrl: string
  dropzoneOptions?: DropzoneOptions
  addItem: (file: File | undefined, fileUrl: string) => unknown
}

export type TAlert = {
  infos: []
  warns: string[]
  errors: []
}

const SingleFileUploadModal: FC<TFileUploadModal> = ({
  isShowFileImage,
  fileData,
  fileImageUrl,
  addItem,
  dropzoneOptions,
  ...props
}) => {
  //#region [state]
  const disPatch: AppDispatch = useDispatch()
  const [uploadFile, setUploadFile] = useState<File>()
  const [uploadFileUrl, setUploadFileUrl] = useState<string>("")
  const [uploadFileName, setUploadFileName] = useState<string>("")

  const onDropAccepted = useCallback(async (acceptedFiles: File[]) => {
    // 先頭ファイル以外は無視
    const acceptedFile = acceptedFiles[0]
    const uploadFileUrl = URL.createObjectURL(acceptedFile)

    setUploadFileUrl(uploadFileUrl)
    setUploadFile(acceptedFile)
    setUploadFileName(acceptedFile.name)
  }, [])

  const { getRootProps, getInputProps, fileRejections, isDragActive, open } =
    useDropzone({
      noClick: true,
      ...dropzoneOptions,
      onDropAccepted,
      disabled: fileData != null,
    })

  //#endregion

  //#region [method]
  // 選択ファイルの削除
  const deleteFile = () => {
    URL.revokeObjectURL(uploadFileUrl!)
    setUploadFile(undefined)
    setUploadFileName("")
    setUploadFileUrl("")
  }
  //#endregion

  //#region [effect]
  useEffect(() => {
    if (props.isShow) {
      if (fileData == null) {
        setUploadFile(undefined)
        setUploadFileUrl("")
        setUploadFileName("")
      } else {
        setUploadFile(undefined)
        setUploadFileName(fileData.ファイル名)

        if (isShowFileImage) {
          setUploadFileUrl(fileImageUrl ?? "")
        } else {
          setUploadFileUrl(fileData.ファイルURL ?? "")
        }
      }
    } else {
      setUploadFile(undefined)
      setUploadFileUrl("")
      setUploadFileName("")
    }
  }, [props.isShow, fileData])

  //#endregion

  return (
    <ModalOuter
      {...props}
      footer={
        <>
          <>
            <Button
              // 新規登録時かつファイルURLがない場合は無効
              disabled={fileData == null && uploadFileUrl === ""}
              onClick={() => {
                // 既存データ更新時かつコメントに変更がない場合
                if (fileData != null) {
                  let isUpdating = true

                  // URLに変更があったか確認
                  if (isShowFileImage) {
                    isUpdating = fileImageUrl !== uploadFileUrl
                  } else {
                    isUpdating = fileData.ファイルURL !== uploadFileUrl
                  }

                  // 変更がない場合は何もせずウィンドウを閉じる
                  if (!isUpdating) {
                    props.setIsShow(false)
                    return
                  }
                }
                addItem(uploadFile, uploadFileUrl)
              }}>
              登録
            </Button>
          </>
        </>
      }>
      {/* 新規でない かつ アップロードファイルが無い場合 */}
      <div className={fileData != null || uploadFileUrl !== "" ? "d-none" : ""}>
        <div {...getRootProps({ className: "drop-zone-panel" })}>
          <input {...getInputProps()} aria-label="dragAndDropInput" />
          {isDragActive ? (
            <p>ここにファイルをドロップしてください</p>
          ) : (
            <>
              <p> ファイルをドラッグ＆ドロップしてください。</p>
              <p> もしくはボタンをクリックしファイルを選択してください</p>
              <Button type="button" onClick={open}>
                ファイルを選択する
              </Button>
            </>
          )}
        </div>
      </div>
      <div>
        {uploadFileUrl !== "" && (
          <>
            {/* 画像表示時 */}
            {isShowFileImage && (
              <>
                <div>
                  <img
                    className="upload-file-thumbnail"
                    src={uploadFileUrl}
                    alt={uploadFileName}
                  />
                </div>
                <a
                  href={uploadFileUrl}
                  target="_blank"
                  rel="noopener noreferrer">
                  {uploadFileName}
                </a>
              </>
            )}
            {/* 画像非表示時 */}
            {!isShowFileImage && (
              <>
                {(fileData == null || fileData?.isNewFile) && (
                  <p>{uploadFileName}</p>
                )}
                {!fileData?.isNewFile && (
                  <a
                    href={uploadFileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      if (!fileData?.isNewFile) {
                        e.preventDefault()
                        const service = new ContentService()
                        service
                          .get(fileData!.ファイルURL!)
                          .then((blob) => {
                            saveAs(blob, fileData!.ファイル名!)
                          })
                          .catch((err) => disPatch(setAlerts(err)))
                      }
                    }}>
                    {uploadFileName}
                  </a>
                )}
              </>
            )}
            {/* 新規登録時のみ削除可 */}
            {fileData == null && (
              <div>
                <Button
                  className="m-1"
                  variant="waiting"
                  onClick={() => {
                    deleteFile()
                  }}>
                  削除
                </Button>
              </div>
            )}
          </>
        )}
        {fileRejections.map((rejectFile) => {
          return (
            <div key={rejectFile.file.name}>
              <p>fileName:{rejectFile.file.name}</p>
              {rejectFile.errors.map((e) => (
                <p key={e.code}>{`${e.code}:${e.message}`}</p>
              ))}
            </div>
          )
        })}
      </div>
    </ModalOuter>
  )
}

export default SingleFileUploadModal
